import React from "react";

import { Tabs } from "antd";


import EmployeeOrganizationTab from "./EmployeeOrganizationChartTab";

export default function SidebarOrganizationTab() {
  const items = [
    {
      key: "1",
      label: "Organization Chart",
      children: <EmployeeOrganizationTab />,
    },
  ];
  return (
    <div className="organization page-container bg-customBg ">
      <div className=" full-width-container">
        <div className="organization_header"></div>

        <div className="organization__Tab bg-white relative mt-16">
          <Tabs items={items} />
        </div>
      </div>
    </div>
  );
}
